// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"77":"new-born","103":"engagement","133":"olly","522":"wedding","569":"one-year-old"}[chunkId] || chunkId) + "." + {"77":"f0686e50","103":"c3981ed3","133":"02fa47a0","506":"7fd1f7b0","522":"5cec22cd","569":"c4dc6913"}[chunkId] + ".js";
};